import { render, staticRenderFns } from "./RequestPasswordRecovery.vue?vue&type=template&id=7ed0c4e9&"
import script from "./RequestPasswordRecovery.vue?vue&type=script&lang=js&"
export * from "./RequestPasswordRecovery.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports